/**
 * TEMU bg.goods.brand.get / bg.glo.goods.brand.get 响应解析
 */

function normalizeBrandPayload(raw) {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw;
  if (Array.isArray(raw.data)) return raw.data;
  if (Array.isArray(raw.brands)) return raw.brands;
  if (Array.isArray(raw.pageItems)) return raw.pageItems;
  return [];
}

function normalizeIpPayload(raw) {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw;
  if (Array.isArray(raw.list)) return raw.list;
  if (Array.isArray(raw.ips)) return raw.ips;
  return [];
}

export function flattenBrandRows(raw) {
  return normalizeBrandPayload(raw).map((item, index) => {
    const brandId = item?.brandId ?? item?.brand_id ?? item?.brand_code ?? item?.brandCode;
    const brandName = item?.brandNameEn
      || item?.brand_name_en
      || item?.brandName
      || item?.brand_name
      || '—';
    return {
      key: brandId != null ? String(brandId) : `brand-${index}`,
      brandCode: brandId != null ? String(brandId) : '—',
      brandName: brandName || '—',
      vid: item?.vid != null ? String(item.vid) : '',
      regSerialCode: item?.regSerialCode || item?.reg_serial_code || '',
    };
  });
}

export function flattenIpRows(raw) {
  return normalizeIpPayload(raw).map((item, index) => ({
    key: String(item?.id ?? item?.ipId ?? index),
    ipId: item?.ipId != null ? String(item.ipId) : '—',
    ipName: item?.ipName || '—',
    ipNameCn: item?.ipNameCn || '—',
    ipGroupId: item?.ipGroupId != null ? String(item.ipGroupId) : '—',
    ipGroupName: item?.ipGroupName || '—',
  }));
}

export function countBrandRows(raw) {
  return flattenBrandRows(raw).length;
}

export function countIpRows(raw) {
  return flattenIpRows(raw).length;
}
